import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { useCelleraTheme } from "theme/useCelleraTheme";

interface ConfirmDeleteModalProps {
  open: boolean;
  medicineName: string;
  onClose: () => void;
  onConfirm: () => void;
  isDeleting?: boolean;
}

function ConfirmDeleteModal({
  open,
  medicineName,
  onClose,
  onConfirm,
  isDeleting = false,
}: ConfirmDeleteModalProps) {
  const { colors } = useCelleraTheme();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
        },
      }}
    >
      <DialogTitle
        sx={{
          fontWeight: 600,
          fontSize: "1.25rem",
          pb: 1,
        }}
      >
        Remove Medicine
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          sx={{
            color: colors.text.secondary,
          }}
        >
          Are you sure you want to remove{" "}
          <strong style={{ color: colors.text.primary }}>{medicineName}</strong>{" "}
          from this prescription?
        </DialogContentText>
      </DialogContent>
      <DialogActions
        sx={{
          px: 3,
          pb: 2,
          gap: 1,
        }}
      >
        <Button
          onClick={onClose}
          variant="outlined"
          disabled={isDeleting}
          sx={{
            textTransform: "none",
            borderColor: colors.border.main,
            color: colors.text.primary,
            "&:hover": {
              borderColor: colors.border.dark,
              backgroundColor: colors.background.secondary,
            },
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          disabled={isDeleting}
          sx={{
            textTransform: "none",
            backgroundColor: colors.error[500],
            "&:hover": {
              backgroundColor: colors.error[600],
            },
          }}
        >
          {isDeleting ? "Removing..." : "Remove"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmDeleteModal;
